// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ────────────────────────────────────────────────────────────────────────────
   ConnectionDiagram — diagrama «desde el punto de vista de X».
   Dos vistas en la misma tarjeta: puertos a la izquierda, cadena a la derecha.
   Comparte tokens del tema con las fichas (sf2 / dv).
   ──────────────────────────────────────────────────────────────────────────── */

.cdg-wrap {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-height: 0;
}

.cdg-head {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.cdg-title { font-weight: 700; font-size: 0.88rem; }
.cdg-counts { font-size: 0.74rem; color: var(--text-muted); }
.cdg-spacer { flex: 1 1; }
.cdg-error { font-size: 0.74rem; color: #fca5a5; }

.cdg-btn {
  padding: 3px 9px;
  border-radius: 7px;
  border: 1px solid var(--border);
  background: var(--bg-toolbar);
  color: var(--text-secondary);
  font-size: 0.76rem;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
}
.cdg-btn:hover:not(:disabled) { background: var(--bg-card); color: var(--text-primary); }
.cdg-btn:disabled { opacity: 0.5; cursor: default; }

.cdg-body {
  display: grid;
  grid-template-columns: 260px minmax(0, 1fr);
  gap: 10px;
  align-items: start;
}
@media (max-width: 900px) {
  .cdg-body { grid-template-columns: minmax(0, 1fr); }
}

/* ── Vista 1: puertos ───────────────────────────────────────────────────── */
.cdg-ports {
  max-height: 380px;
  overflow-y: auto;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--bg-toolbar);
  padding: 6px;
}
.cdg-group {
  font-size: 0.66rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--text-muted);
  margin: 6px 2px 4px;
}
.cdg-port {
  width: 100%;
  display: flex;
  align-items: baseline;
  gap: 6px;
  padding: 4px 6px;
  margin-bottom: 2px;
  border-radius: 6px;
  border: 1px solid transparent;
  background: transparent;
  color: var(--text-primary);
  font-size: 0.76rem;
  text-align: left;
  cursor: pointer;
}
.cdg-port:hover { background: var(--bg-card); border-color: var(--border); }
.cdg-port.is-active { border-color: var(--accent, #3b82f6); background: var(--bg-card); }
.cdg-port.is-wired .cdg-port-label::after {
  content: '';
  display: inline-block;
  width: 6px;
  height: 6px;
  margin-left: 5px;
  border-radius: 50%;
  background: #0d9488;
  vertical-align: middle;
}
.cdg-port-label { font-weight: 700; white-space: nowrap; }
.cdg-port-far {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.72rem;
  color: var(--text-secondary);
}
.cdg-port-far.is-free { color: var(--text-muted); font-style: italic; }

/* ── Vista 2: cadena ────────────────────────────────────────────────────── */
.cdg-chain {
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--bg-card);
  padding: 10px 12px;
  min-height: 120px;
}
.cdg-chain-head {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 10px;
  font-size: 0.8rem;
}
.cdg-chain-head span { font-size: 0.72rem; color: var(--text-muted); }

.cdg-flow {
  display: flex;
  align-items: stretch;
  gap: 4px;
  flex-wrap: wrap;
}

.cdg-step {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 6px 10px;
  border-radius: 9px;
  border: 1px solid var(--border);
  background: var(--bg-toolbar);
  min-width: 130px;
}
.cdg-step.is-focus {
  border-color: var(--accent, #3b82f6);
  box-shadow: 0 0 0 1px color-mix(in srgb, var(--accent, #3b82f6) 45%, transparent);
}
.cdg-step-icon { font-size: 1rem; line-height: 1; }
.cdg-step-txt { display: flex; flex-direction: column; min-width: 0; }
.cdg-step-txt b {
  font-size: 0.78rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 170px;
}
.cdg-step-txt span { font-size: 0.7rem; color: var(--text-muted); }

/* Cable entre dos pasos */
.cdg-cable {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  min-width: 92px;
  padding: 0 2px;
}
.cdg-cable-line {
  display: block;
  width: 100%;
  height: 2px;
  border-radius: 2px;
  background: linear-gradient(90deg, var(--border), var(--accent, #3b82f6), var(--border));
}
.cdg-cable-txt {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 0.66rem;
  color: var(--text-secondary);
  white-space: nowrap;
}
.cdg-cable-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 0.35);
}
.cdg-cable-x {
  border: 0;
  background: none;
  padding: 0 2px;
  font-size: 0.68rem;
  color: var(--text-muted);
  cursor: pointer;
}
.cdg-cable-x:hover:not(:disabled) { color: #fca5a5; }

.cdg-empty {
  padding: 18px 6px;
  text-align: center;
  font-size: 0.8rem;
  color: var(--text-muted);
}
.cdg-note {
  margin-top: 10px;
  font-size: 0.72rem;
  color: var(--text-muted);
  line-height: 1.35;
}
`, "",{"version":3,"sources":["webpack://./src/components/ConnectionDiagram.css"],"names":[],"mappings":"AAAA;;;;iFAIiF;;AAEjF;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA,aAAa,gBAAgB,EAAE,kBAAkB,EAAE;AACnD,cAAc,kBAAkB,EAAE,wBAAwB,EAAE;AAC5D,cAAc,SAAO,EAAE;AACvB,aAAa,kBAAkB,EAAE,cAAc,EAAE;;AAEjD;EACE,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,6BAA6B;EAC7B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA,gCAAgC,0BAA0B,EAAE,0BAA0B,EAAE;AACxF,oBAAoB,YAAY,EAAE,eAAe,EAAE;;AAEnD;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,kBAAkB;AACpB;AACA;EACE,YAAY,qCAAqC,EAAE;AACrD;;AAEA,8EAA8E;AAC9E;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,6BAA6B;EAC7B,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA,kBAAkB,0BAA0B,EAAE,2BAA2B,EAAE;AAC3E,sBAAsB,oCAAoC,EAAE,0BAA0B,EAAE;AACxF;EACE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;AACA,kBAAkB,gBAAgB,EAAE,mBAAmB,EAAE;AACzD;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;AAC9B;AACA,wBAAwB,wBAAwB,EAAE,kBAAkB,EAAE;;AAEtE,8EAA8E;AAC9E;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;AACnB;AACA,uBAAuB,kBAAkB,EAAE,wBAAwB,EAAE;;AAErE;EACE,aAAa;EACb,oBAAoB;EACpB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,iFAAiF;AACnF;AACA,iBAAiB,eAAe,EAAE,cAAc,EAAE;AAClD,gBAAgB,aAAa,EAAE,sBAAsB,EAAE,YAAY,EAAE;AACrE;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;AACA,qBAAqB,iBAAiB,EAAE,wBAAwB,EAAE;;AAElE,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,wFAAwF;AAC1F;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,4BAA4B;EAC5B,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qCAAqC;AACvC;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;AACjB;AACA,oCAAoC,cAAc,EAAE;;AAEpD;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;AACnB","sourcesContent":["/* ────────────────────────────────────────────────────────────────────────────\r\n   ConnectionDiagram — diagrama «desde el punto de vista de X».\r\n   Dos vistas en la misma tarjeta: puertos a la izquierda, cadena a la derecha.\r\n   Comparte tokens del tema con las fichas (sf2 / dv).\r\n   ──────────────────────────────────────────────────────────────────────────── */\r\n\r\n.cdg-wrap {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  min-height: 0;\r\n}\r\n\r\n.cdg-head {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  flex-wrap: wrap;\r\n}\r\n.cdg-title { font-weight: 700; font-size: 0.88rem; }\r\n.cdg-counts { font-size: 0.74rem; color: var(--text-muted); }\r\n.cdg-spacer { flex: 1; }\r\n.cdg-error { font-size: 0.74rem; color: #fca5a5; }\r\n\r\n.cdg-btn {\r\n  padding: 3px 9px;\r\n  border-radius: 7px;\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-toolbar);\r\n  color: var(--text-secondary);\r\n  font-size: 0.76rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  white-space: nowrap;\r\n}\r\n.cdg-btn:hover:not(:disabled) { background: var(--bg-card); color: var(--text-primary); }\r\n.cdg-btn:disabled { opacity: 0.5; cursor: default; }\r\n\r\n.cdg-body {\r\n  display: grid;\r\n  grid-template-columns: 260px minmax(0, 1fr);\r\n  gap: 10px;\r\n  align-items: start;\r\n}\r\n@media (max-width: 900px) {\r\n  .cdg-body { grid-template-columns: minmax(0, 1fr); }\r\n}\r\n\r\n/* ── Vista 1: puertos ───────────────────────────────────────────────────── */\r\n.cdg-ports {\r\n  max-height: 380px;\r\n  overflow-y: auto;\r\n  border: 1px solid var(--border);\r\n  border-radius: 8px;\r\n  background: var(--bg-toolbar);\r\n  padding: 6px;\r\n}\r\n.cdg-group {\r\n  font-size: 0.66rem;\r\n  font-weight: 700;\r\n  letter-spacing: 0.05em;\r\n  text-transform: uppercase;\r\n  color: var(--text-muted);\r\n  margin: 6px 2px 4px;\r\n}\r\n.cdg-port {\r\n  width: 100%;\r\n  display: flex;\r\n  align-items: baseline;\r\n  gap: 6px;\r\n  padding: 4px 6px;\r\n  margin-bottom: 2px;\r\n  border-radius: 6px;\r\n  border: 1px solid transparent;\r\n  background: transparent;\r\n  color: var(--text-primary);\r\n  font-size: 0.76rem;\r\n  text-align: left;\r\n  cursor: pointer;\r\n}\r\n.cdg-port:hover { background: var(--bg-card); border-color: var(--border); }\r\n.cdg-port.is-active { border-color: var(--accent, #3b82f6); background: var(--bg-card); }\r\n.cdg-port.is-wired .cdg-port-label::after {\r\n  content: '';\r\n  display: inline-block;\r\n  width: 6px;\r\n  height: 6px;\r\n  margin-left: 5px;\r\n  border-radius: 50%;\r\n  background: #0d9488;\r\n  vertical-align: middle;\r\n}\r\n.cdg-port-label { font-weight: 700; white-space: nowrap; }\r\n.cdg-port-far {\r\n  flex: 1;\r\n  min-width: 0;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  font-size: 0.72rem;\r\n  color: var(--text-secondary);\r\n}\r\n.cdg-port-far.is-free { color: var(--text-muted); font-style: italic; }\r\n\r\n/* ── Vista 2: cadena ────────────────────────────────────────────────────── */\r\n.cdg-chain {\r\n  border: 1px solid var(--border);\r\n  border-radius: 8px;\r\n  background: var(--bg-card);\r\n  padding: 10px 12px;\r\n  min-height: 120px;\r\n}\r\n.cdg-chain-head {\r\n  display: flex;\r\n  align-items: baseline;\r\n  gap: 8px;\r\n  margin-bottom: 10px;\r\n  font-size: 0.8rem;\r\n}\r\n.cdg-chain-head span { font-size: 0.72rem; color: var(--text-muted); }\r\n\r\n.cdg-flow {\r\n  display: flex;\r\n  align-items: stretch;\r\n  gap: 4px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.cdg-step {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 7px;\r\n  padding: 6px 10px;\r\n  border-radius: 9px;\r\n  border: 1px solid var(--border);\r\n  background: var(--bg-toolbar);\r\n  min-width: 130px;\r\n}\r\n.cdg-step.is-focus {\r\n  border-color: var(--accent, #3b82f6);\r\n  box-shadow: 0 0 0 1px color-mix(in srgb, var(--accent, #3b82f6) 45%, transparent);\r\n}\r\n.cdg-step-icon { font-size: 1rem; line-height: 1; }\r\n.cdg-step-txt { display: flex; flex-direction: column; min-width: 0; }\r\n.cdg-step-txt b {\r\n  font-size: 0.78rem;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  max-width: 170px;\r\n}\r\n.cdg-step-txt span { font-size: 0.7rem; color: var(--text-muted); }\r\n\r\n/* Cable entre dos pasos */\r\n.cdg-cable {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 2px;\r\n  min-width: 92px;\r\n  padding: 0 2px;\r\n}\r\n.cdg-cable-line {\r\n  display: block;\r\n  width: 100%;\r\n  height: 2px;\r\n  border-radius: 2px;\r\n  background: linear-gradient(90deg, var(--border), var(--accent, #3b82f6), var(--border));\r\n}\r\n.cdg-cable-txt {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 4px;\r\n  font-size: 0.66rem;\r\n  color: var(--text-secondary);\r\n  white-space: nowrap;\r\n}\r\n.cdg-cable-dot {\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  border: 1px solid rgba(0, 0, 0, 0.35);\r\n}\r\n.cdg-cable-x {\r\n  border: 0;\r\n  background: none;\r\n  padding: 0 2px;\r\n  font-size: 0.68rem;\r\n  color: var(--text-muted);\r\n  cursor: pointer;\r\n}\r\n.cdg-cable-x:hover:not(:disabled) { color: #fca5a5; }\r\n\r\n.cdg-empty {\r\n  padding: 18px 6px;\r\n  text-align: center;\r\n  font-size: 0.8rem;\r\n  color: var(--text-muted);\r\n}\r\n.cdg-note {\r\n  margin-top: 10px;\r\n  font-size: 0.72rem;\r\n  color: var(--text-muted);\r\n  line-height: 1.35;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
